/**
 * @generated SignedSource<<07ed322e9fe0d4ea6215e86f3533853e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteLabelCategoryInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteLabelCategoryMutation$variables = {
  input: DeleteLabelCategoryInput;
};
export type deleteLabelCategoryMutation$data = {
  readonly deleteLabelCategory: {
    readonly deletedLabelCategoryId: string | null;
  } | null;
};
export type deleteLabelCategoryMutation = {
  variables: deleteLabelCategoryMutation$variables;
  response: deleteLabelCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteLabelCategoryPayload",
    "kind": "LinkedField",
    "name": "deleteLabelCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedLabelCategoryId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteLabelCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteLabelCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "27cb6933f41288313151974dad555968",
    "id": null,
    "metadata": {},
    "name": "deleteLabelCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation deleteLabelCategoryMutation(\n  $input: DeleteLabelCategoryInput!\n) {\n  deleteLabelCategory(input: $input) {\n    deletedLabelCategoryId\n  }\n}\n"
  }
};
})();

(node as any).hash = "08c4714834d4ab996a7311d33659bc03";

export default node;
